<div class="warning-row">
  <div class="row">
    <div class="col-md-1 col-0-padding" align="center">
      <i class="fa fa-exclamation" aria-hidden="true"></i>
    </div>
    <div class="col-md-10 col-0-padding">
      {{message}}
    </div>
  </div>
</div>
